<template>
    <div>
        <link href="https://img2.233.com/wx/union/pc/fine/category/css/zaojia.css" rel="stylesheet" type="text/css">
        <div class="wx-header-cont" id="wx-header-cont"> 
        <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
        <div class="wx-header-container">
            <div class="fl-box">
          <h1 class="logo"> <a href="/"><img  :src="logo" > </a> </h1>
            <div class="line"></div>
            <div class="wx-subject">
                <h2>造价工程师</h2>
                <i class="dropdown-arrow"></i>
                <div class="subject-list">
                        <a href="./#/jianli">监理工程师</a>
                        <a href="./#/aq">安全工程师</a>
                        <a href="./#/cfe">一级消防工程师</a>
                        <a href="./#/zaojia">造价工程师</a>
                        <a href="./#/jzs1">一级建造师</a>
                        <a href="./#/jzs2">二级建造师</a>
                        <a href="./#/zjy">二级造价工程师</a>
                        <a href="./#/zjxfy">消防设施操作员</a>
                </div>
            </div>
            <div class="head-area  text-gry6 font14 fl m-t-10"  style="display: none;"> 当前地区
                <p class="m-l-15  bg-white fr "><em class="now-area p-0-20">全国版</em><a href="" class="more-area p-0-10">更多地区 </a></p>
                <div class="area_list">
                <ul>
                    <li><a href="/tegang/guojia/#tgtc">全国</a></li>
                    <li><a href="/tegang/shanxi1/#tgtc">陕西</a></li>
                    <li><a href="/tegang/hebei/#tgtc">河北</a></li>
                    <li><a href="/tegang/henan/">河南</a></li>
                    <li><a href="/tegang/sichuan/#tgtc">四川</a></li>
                    <li><a href="/tegang/jiangxi/#tgtc">江西</a></li>
                    <li><a href="/tegang/yunnan/#tgtc">云南</a></li>
                    <li><a href="/tegang/heilongjiang/#tgtc">黑龙江</a></li>
                    <li><a href="/tegang/chongqing/#tgtc">重庆</a></li>
                    <li><a href="/tegang/hubei/#tgtc">湖北</a></li>
                </ul>
                </div>
            </div>
            </div>
            <div class="fr-box"> 
                <!--未登录 -->
                <div class="personal-no" v-if="!isLogin">
                    <p><a target="_blank" :href="'/uc/login?redirecturl='+href" class="red">登录</a>|<a target="_blank" :href="'/uc/register?redirecturl='+href">注册</a></p>
                </div>
                <div class="personal" v-else>
                            <a href="javascript:;" class="pic"><img :src="logoSrc" ><i class="dropdown-arrow"></i></a>
                            <div class="pop-personal">
                                <a href="javascript:" @click="loginout()"><i class="icon"></i><span class="txt">退出</span></a>
                            </div>
                </div>
                <div class="classify"> 
                    <a class="classify-list" href="/shopping/cart" target="_blank" title="购课车">
                    <p class="icon shopping"></p>
                    </a> </div>
                <div v-if="kefu.length>0" class="wx-telephone">
                    <p class="txt1">客服热线</p>
                    <p class="txt2">{{kefu}}</p>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        </div>
        <!--banner-->
        <div class="bg-black"> 
        <!--01banner-->
        <Banner imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/banner01.jpg"></Banner>
        <!--01banner 结束--> 
        <!---02试听区域--->
        <div class="video clearfix">
            <div class="video-layout">
            <div class="subject-tabBox clearfix" >
                <ul class="sub-tabL clearfix">
                <li class="line" @click="changeCourseIndex(i)" v-for="(v,i) in courses.slice(0,4)" :key="i">
                    <a href="javascript: void(0)"  :class="i==courseIndex?'hover':''">{{v.name}}</a>
                </li>
                </ul>
                <div class="Rselect-box" @mouseover="changeIsHoverCourse(true)" @mouseout="changeIsHoverCourse(false)" >
                    <p class="subject-select currt clearfix"><span class="txt">选择其它科目</span><i class="ico"></i></p>
                    <div class="sub-sel-list" v-show="isHoverCourse">
                        <ul>
                        <li v-for="(v,i) in courses.slice(4)" :key="i">
                            <a  @click="changeCourseIndex(i+4)" style="text-overflow:ellipsis; overflow:hidden; white-space:nowrap;" href="javascript: void(0)">{{v.name}}</a>
                        </li>
                        </ul>
                    </div>
                </div>
            </div>
            <myvideo   :isLogin="isLogin"  :allLoginPlayFlag="allLoginPlayFlag"  :unionId="unionId" :classEname="'zaojia'" :logo="logo" :myClassId="courses[courseIndex].myClassId"></myvideo>
            </div>
            <div class="video-bottom"></div>
        </div>
        <!---02试听区域END---> 
        </div>
        <!--03原高级平台班级对比-->
        <banjiduibi :calssName="'造价工程师'" :classEName="'zaojia'"></banjiduibi>
        <!--03原高级平台班级对比 end--> 
            
        <!--04全部班级表格-->
        <quanbubanji :classEname="'zaojia'"></quanbubanji>
        <!--04全部班级表格 end--> 
        <!--06套用官网内容  开始-------------> 


<div class="piece-box piece-two ">
  <!-- 退费保障&证书价值 -->
  <div class="piece-main">
<div class="" id="tfbz">
   <!-- 标题 -->

  <h2 class="title-h2-da   title-h2one">
      <div class="title-s"><span class="title-sapnone"><i>1</i></span><span class="title-sapntwo">证书价值</span></div>
    <div class="title-x"><span>新政策落地后，造价工程师考证春天即将来临</span></div>
    </h2>
  <!--价值-->
  <div class="zj-value clearfix">
    <div class="zj-valuebox zj-valuebox01">
      <div class="value-digital value-digital01"></div> 
      <h3 class="h3-value"><span>NEW</span><strong>市场需求大增</strong></h3>
      <div class="value-new">
        <h4 class="h4-value">新规亮点</h4>
        <p class="value-gc">
        <b>必须配备造价工程师</b>
        <span>凡从事工程建设活动的建设、设计、施工造价咨询等单位，强制要求必须配备证书。</span>
        </p>
      </div>
      <div class="value-market">
        <h4 class="h4-value">新规亮点</h4>
        <p class="value-gc">
        <b>证书供不应求</b>
        <span>造价工程师岗位需求大幅度上涨。</span>
        </p>
      </div>
    </div>  
    <div class="zj-valuebox zj-valuebox02">
      <div class="value-digital value-digital02"></div> 
      <h3 class="h3-value"><span>NEW</span><strong>升职证书</strong></h3>
      <div class="value-new">
        <h4 class="h4-value">新规亮点</h4>
        <p class="value-gc">
        <b>申报高级职称条件</b>
        <span>专业技术人员取得一级造价工程师、二级造价工程师职业资格，可认定其具备工程师、助理工程师职称。</span>
        </p>
      </div>
      <div class="value-market">
        <h4 class="h4-value">新规亮点</h4>
        <p class="value-gc">
        <b>考试热度提升</b>
        <span>证书与职称评选挂钩，想升职加薪可以考此证，考试热度将短期内快速提升。</span>
        </p>
      </div>
    </div>
    <div class="zj-valuebox zj-valuebox03">
      <div class="value-digital value-digital03"></div> 
      <h3 class="h3-value"><span>NEW</span><strong>就业方向更广</strong></h3>
      <div class="value-new">
        <h4 class="h4-value">新规亮点</h4>
        <p class="value-gc">
        <b>纳入国家职业资格目录</b>
        <span>国家对造价工程师实行准入类职业资格制度，纳入国家职业资格目录。</span>
        </p>
      </div>
      <div class="value-market">
        <h4 class="h4-value">新规亮点</h4>
        <p class="value-gc">
        <b>适用范围更广</b>
        <span>职业资格包括从业资格和执业资格，证书认可度更高适用范围更广。</span>
        </p>
      </div>
    </div>
  </div>
  <!--价值end-->
  <div class="zj-explain">
     <div class="zj-explain-title"><span>造价工程师新规定落地后，考证人群将大幅度增长，</span><b>近五年内造价师证书供不应求</b></div>
     <a href="javascript:" @click="scroll(900)">报名拿证</a>
  </div>
</div>
</div>
  <!-- 退费保障&证书价值 end-->
  <!-- 专项突破 -->
  <div class="piece-box piece-three ">
<div class="piece-main clearfix">
  <h2 class="title-h2-da title-h2two">
      <div class="title-s"><span class="title-sapnone"><i>2</i></span><span class="title-sapntwo"><a name="cxtp"></a>专项突破</span></div>
    <div class="title-x"><span>4大专题班强化突破，针对性攻克重难点</span></div>
    </h2>
<!--突破-->
  <div class="zj-overfulfil">
    <div class="zjover-box fl">
      <div class="zjover-left">
        <h4 class="h4-zjover">难点一</h4>
        <p>建筑工程识图与计量是工程技术与计量（土建/安装）科目的高频考点，<span>每年出30分题目，</span>与案例题联系紧密。</p>
        <div class="fraction"><span>30<i>分</i></span><b>考分占比</b></div>
      </div>
      
      <div class="zjover-ke">
        <h3 class="h3-zjover">建筑工程识图与计量</h3>
        <div class="zjover-content">
          <b>主讲内容</b>
          <div class="zjover-wz">
          <p class="zjover-wzp-one"><span>土方工程</span><span>钢筋工程</span><span>桩基工程</span><span>砌筑工程</span></p>
          <p class="zjover-wzp-two"><span>混凝土工程</span><span>装饰装修工程</span><span>措施项目</span></p>
          </div>
        </div>  
      </div>
    </div>
    
    <div class="zjover-box zjover-box-rg fl">
      <div class="zjover-left">
        <h4 class="h4-zjover">难点二</h4>
        <p>工程清单计价规范是工程计价科目重难点，<span>总分100分占30%比重</span>，有大量需要计算的内容，需多做题练习。</p>
        <div class="fraction"><span>30<i>分</i></span><b>考分占比</b></div>
      </div>
      <div class="zjover-ke">
        <h3 class="h3-zjover">工程量清单计价规范</h3>
        <div class="zjover-content">
          <b>主讲内容</b>
          <div class="zjover-wz">
          <p class="zjover-wzp-one"><span>工程计量清单编制</span><span>投标报价</span><span>合同款约定于工程计量</span><span>合同价款调整</span></p>
          <p class="zjover-wzp-two"><span>竣工计算与支付</span><span>竣工结算与支付</span><span>合同解除与合同价款争议的解决</span></p>
          </div>
        </div>  
      </div>
    </div>
    
    <div class="zjover-box fl">
      <div class="zjover-left">
        <h4 class="h4-zjover">难点三</h4>
        <p>工程网络技术部分属于章节，技术含量高，但在案例科目也有涉及，<span>特别是时间参数计算等内容难度极大，</span>必须理解透彻。</p>
        <div class="fraction"><span>22<i>分</i></span><b>考分占比</b></div>
      </div>
      <div class="zjover-ke">
        <h3 class="h3-zjover">造价管理工程网络技术</h3>
        <div class="zjover-content">
          <b>主讲内容</b>
          <div class="zjover-wz">
          <p class="zjover-wzp-w"><span>网络图的相关概念与规则</span><span>双代号网络计划</span><span>单代号网络计划</span>
          <span>双代号时标网络计划</span><span>网络计划的优化、监控与调整</span></p>
          
          </div>
        </div>  
      </div>
    </div>
    
    <div class="zjover-box zjover-box-rg fl">
      <div class="zjover-left">
        <h4 class="h4-zjover">难点四</h4>
        <p>案例分析综合性强，考核难度大，容易失分，且不少案例题分值40分，分值占比高。</p>
        <div class="fraction"><span>40<i>分</i></span><b>考分占比</b></div>
      </div>
      <div class="zjover-ke">
        <h3 class="h3-zjover">案例分析专项突破</h3>
        <div class="zjover-content">
          <b>主讲内容</b>
          <div class="zjover-wz">
          <p class="zjover-wzp-w"><span>精选案例经典考题</span><span>讲解具有代表性经典习题</span>
          <span>详细分析出题解题思路</span></p>
          
          </div>
        </div>  
      </div>
    </div>
  </div>
  <div class="zj-zhclass">
    <div class="zj-zhclass-lf fl"><span>想要四大专题班</span><b>购买高端班即可享受</b></div>
    <div class="zj-zhclass-rg fr"> <a href="javascript:void(0);" @click="scroll(900)" class="zj-zhclass-buttons">组合购买</a> </div>
  </div>
<!--突破-->
</div>
</div>
<!-- 专项突破 end -->
<!-- 考点解密 -->
<div class="piece-box piece-four ">
  <h2 class="title-h2-da title-h2two title-h2three">
      <div class="title-s"><span class="title-sapnone"><i>3</i></span><span class="title-sapntwo">考点解密</span></div>
    <div class="title-x"><span>解密各章节分值及核心考点，稳抓重难点得分</span></div>
    </h2>
    
   <!--解密-->
  <div class="test-site">
    <div class="test-box" data-type="{cs1: 'test-cutover',tlist: '.test-site-th span',clist: '.ui-table'}" node-type="menu-tab">
      <p class="test-site-th">
          <span :class="kdIndex==0?'test-cutover':''" @mouseover="changeKdIndex(0)">工程计价<b></b></span>
          <span :class="kdIndex==1?'test-cutover':''" @mouseover="changeKdIndex(1)">造价管理</span>
          <span :class="kdIndex==2?'test-cutover':''" @mouseover="changeKdIndex(2)">土建工程</span>
          <span :class="kdIndex==3?'test-cutover':''" @mouseover="changeKdIndex(3)">安装工程</span>
          <span :class="kdIndex==4?'test-cutover':''" @mouseover="changeKdIndex(4)">案例分析</span></p>
      
<table width="100%" class="ui-table" v-show="kdIndex==0">
 <tbody> 
    <tr>
    <th rowspan="7" class="projects-box  projects-box1">
      <p class="projects"><i>工程计价</i></p>
      <p class="projectc"><i>难度等级</i><span></span></p>
      
    
    </th>
      <th class="projects-box2"><b>章节内容</b></th> 
        <th class="projects-box3"><b>考情分析</b></th> 
      
        </tr>
    <tr>
            <td>第一章  建设工程造价构成</td>
            
      <td rowspan="6">
              <span>第四章易出数字题考点，本章也是案例分析科目的重要考点处。</span>
        <span class="table-top"><em class="table-orange">第五章非常重要，分值占比高，</em>其中变更、索赔、价款结算、调价的内容是案例分析科目的重要考点，需掌握。</span>
            </td>
        </tr>
    <tr>
            <td>第二章  建设工程计价方法与计价依据</td>
      
            
        </tr>
    <tr>
            <td>第三章  建设项目决策和设计阶段工程造价的预测</td>
           
           
        </tr>
    <tr>
            <td>第四章  建设项目发承包阶段合同价款的约定</td>
           
            
        </tr>
    <tr>
            <td><span class="table-orange">第五章  建设施工阶段合同价款的调整和结算</span></td>
            
           
        </tr>
    <tr>
            <td>第六章  建设项目竣工决算的编制和竣工后质量保证金的处理</td>
           
           
        </tr>
    </tbody>
</table>  
<table width="100%" class="ui-table"  v-show="kdIndex==1">
 <tbody> 
    <tr>
    <th rowspan="7" class="projects-box  projects-box1">
    
      <p class="projects"><i>造价管理</i></p>
      <p class="projectc"><i>难度等级</i><span></span></p>
    
    </th>
      <th class=" projects-box2"><b>章节内容</b></th>

           

            <th class="projects-box3"><b>考情分析</b></th>
            
        </tr>
    <tr>
            <td>第一章  工程造价管理及其基本制度</td>
          
      <td rowspan="6">
              <span>以下与案例科目直接相关的内容需掌握：</span>

            
        <span class="table-top">1.工程经济<em class="table-orange">（第四章）</em></span>
              <span class="table-top">2.招投标<em class="table-orange">（第二章第三节、第六章第三节）</em></span>
              <span class="table-top">3.网络计划<em class="table-orange">（第三章第五节）</em></span>
              <span class="table-top">4.网络计划<em class="table-orange">（第三章第五节）</em></span>
            </td>
        </tr>
    <tr>
            <td>第二章  相关法律法规</td>
      
            
        </tr>
    <tr>
            <td>第三章  工程项目管理</td>
            
           
        </tr>
    <tr>
            <td>第四章  工程经济</td>
            
            
        </tr>
    <tr>
            <td><span>第五章  工程项目融资</span></td>
            
           
        </tr>
    <tr>
            <td>第六章  工程建设全过程造价管</td>
           
           
        </tr>
    </tbody>
</table>
<table width="100%" class="ui-table"  v-show="kdIndex==2">
 <tbody> 
    <tr>
    <th rowspan="7" class="projects-box  projects-box1">
    
      <p class="projects"><i>土建工程</i></p>
      <p class="projectc projectc04"><i>难度等级</i><span></span></p>
    
    </th>
      <th class=" projects-box2"><b>章节内容</b></th>
            <th class=" projects-box3"><b>考情分析</b></th>
            
        </tr>
    <tr>
            <td>第一章  工程地质</td>
            
      <td rowspan="5">
              <span><em class="table-orange">土建工程第五章重要，</em>教材篇幅不大，但分值占比超高；其次为章和第三章；第四章次之。</span>
        <span class="table-top">土建各章各节均会出题，且题目呈细微化边缘化的趋势，尤其是表格中的数据。</span>
            
            </td>
        </tr>
    <tr>
            <td>第二章  工程构造</td>
      
            
        </tr>
    <tr>
            <td>第三章  工程材料</td>
           
           
        </tr>
    <tr>
            <td>第四章  工程施工技术</td>
           
            
        </tr>
    <tr>
            <td><span class="table-orange">第五章  工程计量</span></td>
          
           
        </tr>
    
    </tbody>
</table>  
<table width="100%" class="ui-table"  v-show="kdIndex==3">
 <tbody> 
    <tr>
    <th rowspan="7" width="20%" class="projects-box projects-box1">
    
      <p class="projects"><i>安装工程</i></p>
      <p class="projectc projectc04"><i>难度等级</i><span></span></p>
    
    </th>
      <th width="35%" class=" projects-box2"><b>章节内容</b></th>
           
            <th width="45%" class=" projects-box3"><b>考情分析</b></th>
            
        </tr>
    <tr>
       <td><span class="table-orange">第一章  安装工程材料</span></td>
            
      <td rowspan="6">
        <span>安装工程难的题目约占10%，<em class="table-orange">容易的占20%，一般的占70%。</em>记忆内容多，计算题不多。</span>
              <span class="table-top">其中，章至第四章很重要（需掌握），<em class="table-orange">题目均为部分，分值为70分</em>。</span>
        <span class="table-top">而第五章和第六章题目为选做部分，约占30分左右。</span>
            
            </td>
        </tr>
    <tr>
            <td>第二章  安装工程施工技术</td>
      
            
        </tr>
    <tr>
            <td>第三章  安装工程计量</td>
          

           
        </tr>
    <tr>
            <td><span class="table-orange">第四章  通用设备攻工程</span></td>
           
        </tr>
    <tr>
            <td>第五章  管道和设备工程</td>
         
           
        </tr>
    <tr>
            <td>第六章  电气自动化控制工程</td>
           
           
        </tr>
    
    </tbody>
</table>  
<table width="100%" class="ui-table"  v-show="kdIndex==4">
 <tbody> 
    <tr>
    <th rowspan="7" class="projects-box  projects-box1">
    
      <p class="projects"><i>案例分析</i></p>
      <p class="projectc projectc05"><i>难度等级</i><span></span></p>
    

    </th>
      <th class=" projects-box2"><b>章节内容</b></th>
           
            <th class=" projects-box3"><b>考情分析</b></th>
            
        </tr>
    <tr>
       <td><span class="table-orange">第一章  建设项目投资估算与财务评估</span></td>
            

      <td rowspan="6">
        
           <span>以下为各章节典型考题内容，掌握：</span>
 <span class="table-span">第一章：财务评价</span>
 <span class="table-span">第二章：方案选优第三章：图、量、价</span>
 <span class="table-span">第四章：招标程序、投标技巧、评标方法等</span>
 <span class="table-span">第五章：工程合同价款管理</span>
 <span class="table-span">第六章：基于新清单规范下的工程价款结算</span>
            
            </td>
        </tr>
    <tr>
            <td><span class="table-orange">第二章  工程设计、施工方案基数经济分析</span></td>
    
            
        </tr>
    <tr>
            <td><span class="table-orange">第三章  工程计量与计价</span></td>
         
           
        </tr>
    <tr>
            <td><span class="table-orange">第五章  工程合同价款管理</span></td>
           
            
        </tr>
    <tr>

            <td><span class="table-orange">第六章  工程计算与决算</span></td>
            
           
        </tr>
    <tr>
            <td>第四章  建设工程招标投标</td>
            
           
        </tr>
    
    </tbody>
</table>  
</div>
  </div>
   <!--解密-->
</div>
<!-- 考点解密 end -->
<!-- 授课体系 -->
<div class="piece-box piece-five ">
<div class="piece-main">
  <h2 class="title-h2-da title-h2one title-h2four">
      <div class="title-s"><span class="title-sapnone"><i>4</i></span><span class="title-sapntwo">授课体系</span></div>
    <div class="title-x"><span>分段科学备考，零基础全科辅导方案</span></div>
    </h2>

 <!--授课-->
  <div class="m-xh">
  <h3 class="h3-txt"><p><span class="h3-txt-span">01</span><span class="h3-txt-span2">基础阶段</span></p></h3>
    <ul class="system clearfix">
      <li class="system-li">
      <div class="how-law">教材精讲班</div>
      <div class="surmount">
        <p class="surmount-p">
        <span>按照章节顺序精讲教材</span>
          <span>涵盖<i>教材大纲考点</i></span>
        <span>帮助考生夯实基础</span>
        </p>
        <div class="skm-text-bottom">
          <div class="stb-left"></div>
          <div class="btn-right">
           <span>锁分指数</span>
          </div>
        </div>
      </div>
      </li>
        
    </ul>
  <h3 class="h3-txt h3-txt-two"><p><span class="h3-txt-span">02</span><span class="h3-txt-span2">强化阶段</span></p></h3>
    <ul class="system clearfix">
       <li class="system-li">
      <div class="how-law">习题班</div>
      <div class="surmount">
        <p class="surmount-p">
        <span>视频解析历年经典习题</span>
          <span>分析各考点出题方式</span>
        <span>举一反三掌握答题技巧</span>
        </p>
        <div class="skm-text-bottom">
          <div class="stb-left stb-left4"></div>
          <div class="btn-right">
           <span>锁分指数</span>
          </div>
        </div>
      </div>
      </li>
     <li class="system-li">
      <div class="how-law">高频考点班</div>
      <div class="surmount">
        <p class="surmount-p">
        <span>串讲章节核心考点</span>
          <span>浓缩精华只讲干货</span>
        <span>少走弯路狠抓得分要点</span>
        </p>
        <div class="skm-text-bottom">
          <div class="stb-left stb-left4"></div>
          <div class="btn-right">
           <span>锁分指数</span>
          </div>
        </div>
      </div>
      </li>
     <li class="system-li">
      <div class="how-law">专题班</div>
      <div class="surmount">
        <p class="surmount-p">
        <span>针对性强化重难点内容</span>
          <span>专项突破《案例第六题》</span>
        <span>高效掌握得分细节考点</span>
        </p>
        <div class="skm-text-bottom">
          <div class="stb-left stb-left2"></div>
          <div class="btn-right">
           <span>锁分指数</span>
          </div>
        </div>
      </div>
      </li>

    </ul>  
  <h3 class="h3-txt h3-txt-two"><p><span class="h3-txt-span">03</span><span class="h3-txt-span2">冲刺阶段</span></p></h3>
    <ul class="system clearfix"> 
     <li class="system-li">
      <div class="how-law">考题突击班</div>
      <div class="surmount">
        <p class="surmount-p">
        <span>送2套内部试题（电子版）</span>
          <span>视频解析试题答案</span>
        <span>短期高效学习</span>
        </p>
        <div class="skm-text-bottom">
          <div class="stb-left stb-left4"></div>
          <div class="btn-right">
           <span>锁分指数</span>
          </div>
        </div>
      </div>
      </li>
      
     <li class="system-li">
      <div class="how-law">真题解析班</div>
      <div class="surmount">
        <p class="surmount-p">
        <span>视频解析近几年真题</span>
          <span>系统分析各科应试技巧</span>
        <span>深度掌握出题高频考点</span>
        </p>
        <div class="skm-text-bottom">
          <div class="stb-left stb-left4"></div>
          <div class="btn-right">
           <span>锁分指数</span>
          </div>
        </div>
      </div>
      </li> 
    </ul>
  </div>
 <!--授课-->

</div>
</div>
<!-- 授课体系 end -->
<!-- 师资团队 -->
<div class="piece-box piece-seven ">
  <h2 class="title-h2-da title-h2one title-h2four">
      <div class="title-s"><span class="title-sapnone"><i>5</i></span><span class="title-sapntwo">师资团队</span></div>
    <div class="title-x"><span>建造行业老师集结，为你提供高效辅导</span></div>
    </h2>
    <div class="m-teacher">
      <div class="wx-mian wx-mian-teacher" data-type="{cs1: 'teacher-li',tlist: '.teacher-ul li',clist: '.teacher-yr'}
               " node-type="menu-tab">
        <div class="dei"></div>
        <div class="teacher-team" style=" display: no ne">
          <h5 class="h5-teacher">
            <b>造价师资团队</b>
            <span>TEACHER TEAM</span>
            <i class="teacher-ione"></i>
            <i class="teacher-itwo">郭炜、王竹梅、陈江潮等老师聚集</i>
          </h5>
          <ul class="teacher-ul">
            <li :class="teacherIndex==0?'teacher-li':''" @mouseover="changeTeacherIndex(0)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos02.jpg" alt="" data-lzled="true"> </li>
            <li :class="teacherIndex==1?'teacher-li':''" @mouseover="changeTeacherIndex(1)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos01.jpg"  alt="" data-lzled="true"> </li>
            <li :class="teacherIndex==2?'teacher-li':''" @mouseover="changeTeacherIndex(2)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos03.jpg"  alt="" data-lzled="true"> </li>
            <li :class="teacherIndex==3?'teacher-li':''" @mouseover="changeTeacherIndex(3)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos05.jpg"  alt="" data-lzled="true"> </li>
            <li :class="teacherIndex==4?'teacher-li':''" @mouseover="changeTeacherIndex(4)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos06.jpg"  alt="" data-lzled="true"> </li>
            <li :class="teacherIndex==5?'teacher-li':''" @mouseover="changeTeacherIndex(5)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos07.jpg"  alt="" data-lzled="true"> </li>  
            <li :class="teacherIndex==6?'teacher-li':''" @mouseover="changeTeacherIndex(6)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos08.jpg"  alt="" data-lzled="true"> </li> 
            <li :class="teacherIndex==7?'teacher-li':''" @mouseover="changeTeacherIndex(7)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos09.jpg"  alt="" data-lzled="true"> </li>  
            <li :class="teacherIndex==8?'teacher-li':''" @mouseover="changeTeacherIndex(8)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos091.jpg" alt="" data-lzled="true"> </li>  
            <li :class="teacherIndex==9?'teacher-li':''" @mouseover="changeTeacherIndex(9)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos092.jpg" alt="" data-lzled="true"> </li> 
            <li :class="teacherIndex==10?'teacher-li':''" @mouseover="changeTeacherIndex(10)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos093.jpg" alt="" data-lzled="true"> </li> 
            <li :class="teacherIndex==11?'teacher-li':''" @mouseover="changeTeacherIndex(11)"><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laos094.jpg" alt="" data-lzled="true"> </li> 
          </ul>

        </div>
<!--郭炜-->       
<div class="teacher-yr"  v-show="teacherIndex==0">
      <div class="teacher-da fl">
        <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da02.png"  width="221" height="414" alt="" data-lzled="true">
          </div>
        
        <div class="teacher-explain fr">
        <h4 class="teacher-name"><i>郭炜</i></h4>        <div class="teacher-train">
        <span>深谙解题套路的培训达人</span>
        <span>教龄：15年</span> 
              </div>
          
        <div class="teacher-speaker">
          <p class="clearfix"><b>主讲内容</b><span>《工程计价》</span></p>
          <p class="clearfix"><b>课程特色</b><span>讲课热情饱满周到细致，善于提炼教材针对性辅导。</span></p>
          <p class="clearfix"><b>专业背景</b><span>土木工程专业博士，985名校副教授，全国多家知名培训机构特聘教授，主持参与教育部多项科研项目，一级建造师，造价工程师，高级经济师。</span></p>
          
        </div>

        
        </div>

        
        
        </div>
<!--郭炜 end-->   
<!--陈江潮-->      
<div class="teacher-yr" v-show="teacherIndex==1">
      <div class="teacher-da fl">
        <i></i><img  src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da01.png" width="221" height="414" alt="" data-lzled="true">
          </div>
        
        <div class="teacher-explain fr">
        <h4 class="teacher-name"><i>陈江潮</i></h4>
        <div class="teacher-train">
        <span>学识渊博的实战派考证培训老师 </span>
        <span>教龄：15年</span> 
              </div>
          

        <div class="teacher-speaker">
          <p class="clearfix"><b>主讲内容</b><span>《案例分析》</span></p>
          <p class="clearfix"><b>课程特色</b><span>有多年造价定额编制及实操经验，实战性强。</span></p>
          <p class="clearfix"><b>专业背景</b><span>高校副教授。造价工程师，一级建造师，监理工程师，招标师。</span></p>
          
        </div>
        
        </div>
        
        
        </div>
      
<!--陈江潮 end-->  
      
<!--王竹梅-->  
<div class="teacher-yr" v-show="teacherIndex==2">
      <div class="teacher-da fl">
        <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da03.png" width="221" height="414" alt="" data-lzled="true">
          </div>
        
        <div class="teacher-explain fr">
        <h4 class="teacher-name"><i>王竹梅</i></h4>
        <div class="teacher-train">
        <span>考点总结高手，高级培训讲师 </span>

        <span>教龄：12年</span> 
              </div>
          
        <div class="teacher-speaker">
          <p class="clearfix"><b>主讲内容</b><span>《造价管理》</span></p>
          <p class="clearfix"><b>课程特色</b><span>讲课通俗易懂、擅于归纳、总结、对比、辨析，将复杂知识简单化，便于理解与记忆。</span></p>
          <p class="clearfix"><b>专业背景</b><span>中国人民大学硕士，近20年工程造价咨询实战经验，全国高级培训师，参与美国估价师学会出版的《不动产估价》（第11版）以及英文《不动产估价词典》的翻译。</span></p>
          
        </div>
        
        </div>
        
        
        </div> 
<!--王竹梅 end-->
      
<!--李恺-->     
<div class="teacher-yr" v-show="teacherIndex==3">
              <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da05.png"  width="221" height="414" alt="" data-lzled="true">
                  </div>
                
                <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>李恺</i></h4>
                <div class="teacher-train">
                <span>造价工程师<br>一级消防工程师</span>
                <span>教龄：6年</span> 
                      </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《建设工程技术与计量》（安装）</span></p>
                  <p class="clearfix"><b>课程特色</b><span>针对考试有独特的教学方法，应试性极强。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>注册安全工程师、注册一级建造师、注册造价工程师。</span></p>
                  
                </div>
                
                </div>
                
                
                </div>
<!--李恺 end-->
  
<!--凌平平-->      
<div class="teacher-yr" v-show="teacherIndex==4">
        <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da06.png"  width="221" height="414" alt="" data-lzled="true">
              </div>
                
        <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>凌平平</i></h4>
                <div class="teacher-train">
                <span>建筑类考试培训女神</span>
                <span>教龄：10年</span> 
                      </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《技术与计量（交通-公路）》</span></p>
                  <p class="clearfix"><b>课程特色</b><span>授课全面细致，重难点突出，例题搭配得当，讲解通俗易懂，学员仿若亲临工地现场。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>高校副教授，注册一级建造师</span></p>
                  
                </div>
                
                </div>
          
</div>
<!--凌平平 end-->
  
  
<!--李俊宏-->      
<div class="teacher-yr" v-show="teacherIndex==5">
        <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da07.png"  width="221" height="414" alt="" data-lzled="true">
              </div>
                
        <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>李俊宏</i></h4>
                <div class="teacher-train">
                <span>真正的水利高手</span>
                <span>教龄：10年</span> 
               </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《案例分析（水利）》</span></p>
                  <p class="clearfix"><b>课程特色</b><span>讲课应试性强，善于讲解案例题将所有知识点融会贯通。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>博士，知名水利院校副教授，参与了三峡水利枢纽工程、南水北调等重大工程，第一次全国水利普查国家级普查员。</span></p>
                  
                </div>
                
                </div>
           
</div>
<!--李俊宏 end-->
  
  
<!--赵亮平-->      
<div class="teacher-yr" v-show="teacherIndex==6">
        <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da08.png?v=2"  width="221" height="414" alt="" data-lzled="true">
              </div>
                
        <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>赵亮平</i></h4>
                <div class="teacher-train">
                <span>零基础也能学透</span>
                 
               </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《案例分析（交通-公路）》</span></p>
                  <p class="clearfix"><b>课程特色</b><span>对基础知识进行铺垫式讲解，深入透彻，对案例理解和掌握帮助性大。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>博士，注册一级建造师，注册造价工程师</span></p>
                  
                </div>
                
                </div>
           
</div>
<!--赵亮平 end-->
  
  
<!--张思雨-->      
<div class="teacher-yr" v-show="teacherIndex==7">
        <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da09.png"  width="221" height="414" alt="" data-lzled="true">
              </div>
                
        <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>张思雨</i></h4>
                <div class="teacher-train">
                <span>深受学员欢迎</span>
                 
               </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《技术与计量（水利）》</span></p>
                  <p class="clearfix"><b>课程特色</b><span>思路清晰，逻辑性强，知识点总结到位，重难点明确。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>硕士研究生，注册一级建造师，供职于水利部某流域机构，从事水利工程建设管理十余年。</span></p>
                  
                </div>
                
                </div>
           
</div>
<!--张思雨 end-->
  
  
<!--钟炜-->     
<div class="teacher-yr" v-show="teacherIndex==8">
        <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da091.png"  width="221" height="414" alt="" data-lzled="true">
              </div>
                
        <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>钟炜</i></h4>
                <div class="teacher-train">
                <span>资深土建名师</span>
                 
               </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《技术与计量（土建）》</span></p>
                  <p class="clearfix"><b>课程特色</b><span>专业功底强，授课深入浅出，善于帮助学员进行总结。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>天津大学博士，天津理工大学管理学院副教授，硕士生导师，承担国家级、省部级各类科研项目4项。</span></p>
                  
                </div>
                
                </div>
           
</div>
<!--钟炜 end-->
  
<!--陈冬铭-->      
<div class="teacher-yr" v-show="teacherIndex==9">
        <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da092.png" width="221" height="414" alt="" data-lzled="true">
              </div>
                
        <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>陈冬铭</i><!--<a href="javascript:;" data-type="{'TeacherID':'913','title':'陈冬铭老师'}" node-type="menu-wx-popup-kc"><i></i><span>立即试听</span></a>--></h4>
                <div class="teacher-train">
                <span>深谙命题规律</span>
                 
               </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《技术与计量（交通-水运）》、《案例分析（交通-水运）》</span></p>
                  <p class="clearfix"><b>课程特色</b><span>考情研究透彻，考点方向把握准确，善于化繁为简。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>注册一级建造师、高级工程师。</span></p>
                  
                </div>
                
                </div>
           
</div>
<!--陈冬铭 end-->  
  <!--朱俊文-->      
<div class="teacher-yr" v-show="teacherIndex==10">
        <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da093.png"  width="221" height="414" alt="" data-lzled="true">
              </div>
                
        <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>朱俊文</i><!--<a href="javascript:;" data-type="{'TeacherID':'913','title':'陈冬铭老师'}" node-type="menu-wx-popup-kc"><i></i><span>立即试听</span></a>--></h4>
                <div class="teacher-train">
                <span>建筑业内明星老师</span>
                 
               </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《建设工程造价管理》</span></p>
                  <p class="clearfix"><b>课程特色</b><span>授课幽默风趣，条理清晰，重点突出，能帮助学员显著缩短复习时间。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>高校讲师、注册造价工程师、注册一级建造师、培训学员百万人次。</span></p>
                  
                </div>
                
                </div>
           
</div>
<!--朱俊文 end-->  


<!--刘满-->     
<div class="teacher-yr" v-show="teacherIndex==11">
        <div class="teacher-da fl">
                <i></i><img src="https://img2.233.com/wx/union/pc/fine/category/img/zaojia/laosi-da094.png"  width="221" height="414" alt="" data-lzled="true">
              </div>
                
        <div class="teacher-explain fr">
                <h4 class="teacher-name"><i>刘满</i><!--<a href="javascript:;" data-type="{'TeacherID':'913','title':'陈冬铭老师'}" node-type="menu-wx-popup-kc"><i></i><span>立即试听</span></a>--></h4>
                <div class="teacher-train">
                <span>案例牛人
</span>
                 
               </div>
                  
                <div class="teacher-speaker">
                  <p class="clearfix"><b>主讲内容</b><span>《案例分析（土建）》</span></p>
                  <p class="clearfix"><b>课程特色</b><span>深谙土建案例知识体系，深入讲解原理、方法和技巧，学员提分快。</span></p>
                  <p class="clearfix"><b>专业背景</b><span>注册造价工程师、拥有多年造价管理实战经验。</span></p>
                  
                </div>
                
                </div>
           
</div>
<!--刘满 end--> 
  
</div>
</div>
</div>
<!-- 师资团队 end -->
<!-- 政策解读 -->
<div class="piece-box piece-nine ">
<div class="piece-main">
  <h2 class="title-h2-da title-h2five">
      <div class="title-s"><span class="title-sapnone"><i>6</i></span><span class="title-sapntwo">政策解读</span></div>
    <div class="title-x"><span>改革后考试难度增大，抢先拿证才是王道</span></div>
    </h2>
  <!--解读-->
  <div class="policy">
       <div class="policy-lbx01"></div>
     <div class="policy-lbx02"></div>
    <p class="policy-th"><span class="policy-old">旧规定<i></i></span> <span class="policy-new">新规定<i></i></span> <span class="policy-new">新规解读<i></i></span></p>
    <div class="policy-box">
      <div class="policy-lbx"></div>
     <table width="100%" class="ui-table-row">
    
    <tbody>
        <tr>
      <td class="exam-b"><span>考试
名称</span></td>
            <td class="examzj-name"><span>造价工程师</span></td>
            <td class="examzj-txt"><span>一级造价工程师，
二级造价工程师</span></td>
      <td class="examzj-txt-r"><span class="exam-thick"><i>造价工程师变为
一级造价工程师，</i>等级提升。</span></td> 
        </tr>
        <tr>
            <td class="exam-b"><span>报考
条件</span></td>
      <td class="examzj-name"><span>工程造价专业，工程或
工程经济类专业</span></td>
            <td class="examzj-txt"><span>放宽了报考条件，非工程或非工程经济专业也可报考。</span></td>
      <td class="examzj-txt-r"><span class="exam-thick"><i>满足报考条件的人数增多，</i>竞争压力增大。</span></td> 
        </tr>
        <tr>
            <td class="exam-b"><span>成绩
管理</span></td>
            <td class="examzj-name"><span>连续2个考试年度通过四科</span></td>
            <td class="examzj-txt"><span>延长成绩管理时间，连续4个考试年度通过四科即可。</span></td>
      <td class="examzj-txt-r"><span class="exam-thick"><i>考试周期延长</i>意味着考试难度也会增大。</span></td> 
        </tr>
        <tr class="table-exam-tr">
            <td class="exam-b"><span>考试
科目</span></td>
            <td class="examzj-name"><span>《工程技术与计量》为基础科目，分土建和安装两个方向。</span></td>
      <td class="examzj-txt"><span>《工程技术与计量》划为专业科目，分土建、安装、交通、水利四个方向 。</span></td>
      <td class="examzj-txt-r"><span class="exam-thick"><i>专业增多考核内容更细致系统，</i>对工作经验要求更高。</span></td> 
        </tr>
       
    </tbody>
</table>
     
     
    </div>
    
    <div class="seize"><a href="javascript:" @click="scroll(900)"><span>查看辅导方案&gt;&gt; </span></a></div>
  </div>
  <!--解读-->
   
</div>
</div>
<!-- 政策解读 end-->
<!-- 智能题库 -->
<div class="wx-course zhinneg_md" id="zntk">
       <div class="wx-mian clearfix"> 
               <!--标题-->
           <h2 class="title-h2-da title-h2five">
      <div class="title-s"><span class="title-sapnone"><i>7</i></span><span class="title-sapntwo">智能题库</span></div>
    <div class="title-x"><span>专业智能，高效提分</span></div>
    </h2>
              <!--标题 end-->
             <div class="zhineng_md_all clearfix"> 
             
               
                   <div class="zntk_md_left">
                         <h4>品质过硬</h4>
                      <ul class="znmd_left_ul clearfix">
                            <li>
                               <div class="znmk_md1 clearfix">
                                     <i class="znmd_icon znmd_img_1"></i>
                                     <div class="znmd_li_title">
                                        <h5>专业解析</h5>
                                        <p>每道题<font class="ft_bold">配有专业答案解析</font><br>解密题目背后的考点逻辑</p>
                                     </div>
                               </div>
                               <a>注：付费学员专享100%章节题量</a>
                            </li>
                            
                            <li>
                               <div class="znmk_md1 clearfix">
                                     <i class="znmd_icon znmd_img_2"></i>
                                     <div class="znmd_li_title">
                                        <h5>助教答疑</h5>
                                        <p>每道题<font class="ft_bold">专业助教答疑服务</font><br>做题不留任何疑问</p>
                                     </div>
                               </div>
                               <a class="znmd_a_bg2">注：付费学员专享</a>
                            </li>
                            
                            <li class="bottom_pt18">
                               <div class="znmk_md1 clearfix">
                                     <i class="znmd_icon znmd_img_3"></i>
                                     <div class="znmd_li_title">
                                        <h5>模考大赛</h5>
                                        <p>万名考生同场闯关做题<br>
<font class="ft_bold">并配套名师直播讲题</font>
</p>
                                     </div>
                               </div>
                             
                            </li>
                            
                            
                            
                            <li class="bottom_pt18">
                               <div class="znmk_md1 clearfix">
                                     <i class="znmd_icon znmd_img_6"></i>
                                     <div class="znmd_li_title">
                                        <h5>大数据提分</h5>
                                        <p>结合考情，分析章节分值<br>
<font class="ft_bold">大数据预判考点</font>，精准提分
</p>
                                     </div>
                               </div>
                             
                            </li>
                            
                            
                         </ul>

                    </div>
                    
                   <div class="zntk_md_right">
                            <h4>智能系统</h4>  
                        <ul class="znmd_right_ul clearfix">
                            <li class="znmd_rli    znmd_rli_bg1">
                                 <div class="znmdli_right_title">
                                        <h5>云计算</h5>
                                        <p>数百万用户高频错题<br><font class="ft_bold2">帮助避开常见失分点</font></p>
                                     </div> 
                            </li>
                            
                            <li class="znmd_rli  color_blue   znmd_rli_bg2">
                                 <div class="znmdli_right_title">
                                        <h5>错题归纳</h5>
                                        <p>错题按章节和题型归类<br><font class="ft_bold2">智能汇总个人薄弱考点</font></p>
                                     </div> 
                            </li>
                            
                      <li class="znmd_rli  color_blue   znmd_rli_bg3">
                                 <div class="znmdli_right_title">
                                        <h5>智能评分</h5>
                                        <p><font class="ft_bold2">系统根据做题数据智能评分</font><br>科学评测做题水准</p>
                                     </div> 
                            </li>
                            
                            
                            
                            
                            
                            <li class="znmd_rli    znmd_rli_bg5">
                                 <div class="znmdli_right_title">
                                        <h5>离线做题</h5>
                                        <p>网校APP支持套题下载<br><font class="ft_bold2">随时随地免流量刷题</font></p>
                                     </div> 
                            </li>
                            
                            
                            
                        </ul>  
                   
                   </div> 
                    
             </div>
        </div>
</div>
<!-- 智能题库 end -->

</div>


<!--06套用官网内容  end-------------> 
<!--05服务特色标题-->
<div class="main-title f-tac m-b-30 p-t-50" >
  <p class="font-bg">CHARACTERISTIC</p>
  <h2 class="font44 fb">选择我们的<em class="text-red fb">四大理由</em></h2>
  <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
</div>
<div class="fuwu-bg ">
  <div class="fuwu-content">
    <div class="fuwu-box">
      <ul class="clearfix m-b-20">
        <li>
          <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">1</span>课程品质高</h4>
          <p class="font15 lh2 p-15">课程专业的教研团队精心打造，<em class="text-red fb">每个课程均经过20+次以上迭代</em>。</p>
        </li>
        <li>
          <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">2</span>老师实力强</h4>
          <p class="font15 lh2 p-15">网校执行严格的<em class="text-red fb">师资淘汰制，由购课学员评分</em>，努力建设零差评老师团队。</p>
        </li>
        <li>
          <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">3</span>学习服务优</h4>
          <p class="font15 lh2 p-15">您在学习课程中遇到任何问题，可在线提问，专业老师<em class="text-red fb">24小时内为您答疑解惑</em>。</p>
        </li>
        <li>
          <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">4</span>售后服务好</h4>
          <p class="font15 lh2 p-15">部分套餐课程享<em class="text-red fb">超长有效期</em>，课程有效期内考试<em class="text-red fb">不过免费重学</em>保障。</p>
        </li>
      </ul>
    </div>
  </div>
</div>
<!--05服务特色 end--> 
    </div>
</template>
<script>
import myvideo from '@/components/myvideo'
import banjiduibi from '@/components/banjiduibi'
import quanbubanji from '@/components/quanbubanji'
import { getMemberPicpath } from '@/request/request.js'
export default {
  name: 'App',
  components: {
    banjiduibi,
    quanbubanji,
    myvideo
  },  
  data() {
    return {
      laoshiindex:0,
      isLogin:false,
      logoSrc:"",
      allLoginPlayFlag:false,
      unionId:"",
      kefu:"",
      logo:"",
      href:"",
      /**
       * 33792	建设工程计价	郭炜	
33793	建设工程造价管理	朱俊文	
33794	案例分析（土建）	陈江潮	刘鸿
			
33795	案例分析（安装）	陈江潮	李恺
			
33796	案例分析（水利）	李俊宏	
33797	案例分析（交通-公路）	赵亮平	
33799	技术与计量（土建）	王洪强	吴新华
30576	案例分析(交通-水运篇) 陈冬铭
33800	技术与计量（安装）	李恺	
33801	技术与计量（水利）	刘二林	
33802	技术与计量（交通-公路）	田劭楠
       */
      courses:[
        {name:'案例分析（土建）',myClassId:33794},
        {name:'案例分析（安装）',myClassId:33795},
        {name:'技术与计量（水利）',myClassId:33801},
        {name:'案例分析（水利）',myClassId:33796},
        {name:'案例分析(交通-水运篇)',myClassId:30576},
        {name:'案例分析(交通-公路篇)',myClassId:33797},
        {name:'技术与计量(交通-公路篇)',myClassId:33802},
        {name:'技术与计量(交通-水运篇)',myClassId:30581},
        {name:'建设工程计价',myClassId:33792},
        {name:'建设工程造价管理',myClassId:33793},
        {name:'技术与计量（土建）',myClassId:33799},
        {name:'技术与计量（安装）',myClassId:33800},
      ],
      courseIndex:0,
      isHoverCourse:false,
      teacherIndex:0,
      kdIndex:0,
    };
  },
  created(){
    this.href=encodeURIComponent(window.location.href);
    var config=JSON.parse(sessionStorage.getItem(window.location.host+"puconfig"));
    if(config.KefuTelList.length>0){
      this.kefu=config.KefuTelList[0].KefuNumber;
    }
    this.unionId=config.UnionId
    this.logo=config.UnionLogo;
    this.allLoginPlayFlag=config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if(token!=undefined){
        this.isLogin=true;
        getMemberPicpath({},(res)=>{
            this.logoSrc=res;
        });
    }else{
        var interval= setInterval(() => {
        token = localStorage.getItem("usertoken");
        if(token!=undefined){
          this.isLogin=true;
          getMemberPicpath({},(res)=>{
            this.logoSrc=res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods:{
      loginout(){
          this.isLogin=false;
          this.logoSrc="";
          localStorage.removeItem("usertoken");
      },
      scroll(num){
        document.documentElement.scrollTop=num;
      },
     changeCourseIndex(i){
       this.courseIndex=i;
     },
    changeIsHoverCourse(flag){
      this.isHoverCourse=flag;
    },
    changehoverindex(i){
      this.hoverindex=i;
    },
    changeTeacherIndex(i){
      this.teacherIndex=i;
    },
    changeKdIndex(i){
        this.kdIndex=i;
    },
  },
}
</script>